module.exports = __webpack_public_path__ + "assets/img/head4-zh.a7c38b98.png";